import {connect, MapDispatchToPropsObject} from 'react-redux';
import {IStore} from '../../../redux/jobs/reducers';
import {TrackedJobsFormContainer as Container} from './container';
import {IJobsFormData} from '../../../redux/modules/jobs/reducer';
import {IJobsSendMailParams, jobsSendMail} from '../../../redux/modules/jobs/actions';

export interface IJobsConnectedProps {
  isLoading: boolean;
  formData?: IJobsFormData;
  submittedForms: Array<string>;
}

export interface IJobsConnectedActions {
  jobsSendMail: (params: IJobsSendMailParams) => void;
}

const mapStateToProps = ({jobs}: IStore): IJobsConnectedProps => ({
  formData: jobs.formData,
  isLoading: jobs.isLoading,
  submittedForms: jobs.submittedForms,
});

const mapDispatchToProps: MapDispatchToPropsObject = {
  jobsSendMail,
};

export const JobsFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Container);
